import {he_scale, madnes_objects, multi, wi_scale} from "./madnes_variables";
import {main_phaser} from "./MadnesApp";

/**
 * @param {string} name
 * @return {boolean}
 */
export function madnes_key_exist(name)
{
    return name in madnes_objects;
}

export function madnes_set_visible(name, bool) {
    madnes_objects[name].visible = bool;
}

export function madnes_get_visible(name) {
    return madnes_objects[name].visible;
}

/**
 * @param {string} name
 * @param {string|null} key
 * @param {number} x
 * @param {number} y
 * @param {number=} alpha
 * @param {number=} a1
 * @param {number=} a2
 * @param {string|number=} frame
 */
export function madnes_add_img(name, key, x, y, alpha, a1, a2, frame, phaser = main_phaser)
{
    if(madnes_key_exist(name))
    {
        console.warn("Object " + name + " already exist.");
        return;
    }

    madnes_objects[name] = phaser.add.image(x * wi_scale, y * he_scale, key, frame);
    madnes_set_scale(name, 1, 1);
    if(typeof alpha != "undefined")
    {
        madnes_set_alpha(name, alpha);
    }

    if(typeof a1 != "undefined" && typeof a2 != "undefined")
    {
        madnes_set_img_center(name, a1, a2);
    }
}

export function phaser_add_img({name, key, x, y, phaser}) {
    madnes_add_img(name, key, x, y, undefined, undefined, undefined, undefined, phaser);
}

/**
 * @param {string} name
 * @param {string|null} key
 * @param {number} x
 * @param {number} y
 * @param {number=} alpha
 * @param {number=} a1
 * @param {number=} a2
 * @param {string|number=} frame
 */
export function madnes_add_sprite(name, key, x, y, alpha, a1, a2, frame, phaser = main_phaser)
{
    if(madnes_key_exist(name))
    {
        console.log("Object " + name + " already exist.");
        return;
    }

    madnes_objects[name] = phaser.add.sprite(x * wi_scale, y * he_scale, key, frame);

    madnes_set_scale(name, 1, 1);
    if(typeof alpha != "undefined")
    {
        madnes_set_alpha(name, alpha);
    }

    if(typeof a1 != "undefined" && typeof a2 != "undefined")
    {
        madnes_set_img_center(name, a1, a2);
    }
}

export function madnes_remove_sprite(name)
{
    if(madnes_key_exist(name))
    {
        if(madnes_objects[name].children.length) {
            madnes_remove_children(name);
        }

        madnes_objects[name].destroy();
        madnes_objects[name] = null;
        delete madnes_objects[name];
    }
}

export function madnes_remove_children(name)
{
    if(typeof madnes_objects[name]["_madnes_childs"] !== 'undefined') {
        for(var child in madnes_objects[name]["_madnes_childs"]) {
            madnes_remove_sprite(child);
        }
        delete madnes_objects[name]["_madnes_childs"];
    }
}

export function madnes_add_child(parentName, childName)
{
    madnes_objects[parentName].addChild(madnes_objects[childName]);

    if(typeof madnes_objects[parentName]["_madnes_childs"] === "undefined") {
        madnes_objects[parentName]["_madnes_childs"] = {};
    }

    madnes_objects[parentName]["_madnes_childs"][childName] = true;
}

export function madnes_remove_child(parentName, childName)
{
    if(!madnes_key_exist(parentName) || !madnes_key_exist(childName))
    {
        console.log("Cannot remove child '" + childName + "' from '" + parentName + "'");
        return;
    }

    madnes_objects[parentName].removeChild(madnes_objects[childName]);
    madnes_remove_sprite(childName);
    delete madnes_objects[parentName]["_madnes_childs"][childName];
}

export function madnes_kill_sprite(name) {
    if(madnes_key_exist(name))
    {
        madnes_objects[name].kill();
    }
}

export function madnes_revive_sprite(name) {
    if(madnes_key_exist(name))
    {
        madnes_objects[name].revive();
    }
}

export function madnes_get_object_name(name)
{
    return madnes_objects[name].name;
}

export function madnes_sprite_set_frame(name, frame)
{
    madnes_objects[name].frame = frame;
}

export function madnes_sprite_set_frame_name(name, frame) {
    madnes_objects[name].frameName = frame;
}

export function madnes_sprite_get_frame_name(name)
{
    return madnes_objects[name].frameName;
}

export function madnes_set_img_center(name, a1, a2) {
    madnes_objects[name].anchor.setTo(a1, a2);
}

/**
 * @param {string} name
 * @param {number} x
 * @param {number} y
 * @param {boolean=} keepVisibility
 */
export function madnes_set_pos(name, x, y, keepVisibility)
{
    madnes_set_pos_x(name, x, keepVisibility);
    madnes_set_pos_y(name, y, keepVisibility);
}

export function madnes_set_scale(name, wi_s, he_s)
{
    //madnes_objects[name].smoothed = true;
    madnes_objects[name].scale.setTo(wi_scale * multi * wi_s, he_scale * multi * he_s);
}

export function madnes_set_alpha(name, alpha)
{
    if(alpha < 0)
    {
        alpha = 0;
    }
    if(alpha > 1)
    {
        alpha = 1;
    }
    madnes_objects[name].alpha = alpha;
}

export function madnes_get_alpha(name) {
    return madnes_objects[name].alpha;
}

export function madnes_add_group(name, phaser = main_phaser) {
    if(madnes_key_exist(name))
    {
        console.log("Object " + name + " already exist.");
        return;
    }
    madnes_objects[name] = phaser.add.group();
}

/**
 * WARN: Destroying group won't remove objects from madnes_objects global! (todo fix)
 * @param {string} name
 * @param {boolean=} destroyChildren
 */
export function madnes_destroy_group(name, destroyChildren)
{
    madnes_objects[name].destroy(destroyChildren);
    delete madnes_objects[name];
}

export function madnes_add_to_group(group_name, name)
{
    madnes_objects[group_name].add(madnes_objects[name]);
}

export function madnes_remove_from_group(group_name, name)
{
    madnes_objects[group_name].remove(madnes_objects[name]);
}

/**
 * @param {string} name
 * @param {number} x
 * @param {boolean=} keepVisibility
 */
export function madnes_set_pos_x(name, x, keepVisibility)
{
    if(!keepVisibility)
    {
        var wi = madnes_get_dimension_wi(name);
        var center = madnes_get_img_center_x(name);
        var scale = madnes_get_scale_x(name);

        var br = wi * scale * ( 1 - center );
        var bl = wi * scale * ( center );

        if(x + wi * 1 < -br || x - wi * 1 > ( 1280 + bl ) ) {
            if(madnes_objects[name].visible) {
                madnes_objects[name].visible = false;
            }
        } else {
            if(!madnes_objects[name].visible) {
                madnes_objects[name].visible = true;
            }
        }
    }

    madnes_objects[name].x = x * wi_scale;
}

/**
 *
 * @param {string} name
 * @param {number} y
 * @param {boolean=} keepVisibility
 */
export function madnes_set_pos_y(name, y, keepVisibility)
{
    if(!keepVisibility)
    {
        var he = madnes_get_dimension_he(name);
        var center = madnes_get_img_center_y(name)
        var scale = madnes_get_scale_y(name);

        var bb = he * scale * ( 1 - center );
        var bu = he * scale * ( center );

        if(y + he * 1 < -bb || y - he * 1  > ( 720 + bu ) )
        {
            if(madnes_objects[name].visible)
            {
                madnes_objects[name].visible = false;
            }
        }
        else
        {
            if(!madnes_objects[name].visible)
            {
                madnes_objects[name].visible = true;
            }
        }
    }

    madnes_objects[name].y = y * he_scale;
}

export function madnes_get_dimension(name)
{
    return {
        'width': madnes_objects[name]['width'] / wi_scale,
        'height': madnes_objects[name]['height'] / wi_scale,
    };
}

export function madnes_get_dimension_wi(name)
{
    return madnes_objects[name].width / wi_scale;
}

export function madnes_get_dimension_he(name)
{
    return madnes_objects[name].height / wi_scale;
}

function madnes_get_img_center_x(name)
{
    if(typeof madnes_objects[name].anchor == "undefined")
    {
        return 0;
    }

    return madnes_objects[name].anchor.x;
}

export function madnes_get_img_center_y(name)
{
    if(typeof madnes_objects[name].anchor == "undefined")
    {
        return 0;
    }

    return madnes_objects[name].anchor.y;
}

export function madnes_get_scale_x(name)
{
    return madnes_objects[name].scale.x / (multi * wi_scale);
}

export function madnes_get_scale_y(name)
{
    return madnes_objects[name].scale.y / (multi * wi_scale);
}

export function madnes_get_pos_x(name) {
    return madnes_objects[name].x / wi_scale;
}

export function madnes_get_pos_y(name) {
    return madnes_objects[name].y / he_scale;
}

export function madnes_set_cstm_val(name, val)
{
    madnes_objects[name]['cstmVal'] = val;
}

export function madnes_get_cstm_val(name)
{
    return madnes_objects[name]['cstmVal'];
}

export function madnes_set_angle(name, ang)
{
    madnes_objects[name].angle = ang;
}

export function madnes_get_angle(name)
{
    return madnes_objects[name].angle;
}

export function madnes_tint(name, color)
{
    madnes_objects[name].tint = color;
}

export function madnes_get_tint(name)
{
    return madnes_objects[name].tint;
}

export function madnes_set_texture(name, key)
{
    madnes_objects[name].loadTexture(key, 0);
    madnes_objects[name].scale.setTo(wi_scale * multi, he_scale * multi);
}

export function madnes_get_texture(name) {
    return madnes_objects[name].key;
}

export function madnes_get_texture_name(name) {
    return madnes_objects[name]['key'];
}

export function madnes_get_texture_wi(name)
{
    return madnes_objects[name].texture.width / wi_scale;
}

export function madnes_get_texture_he(name)
{
    return madnes_objects[name].texture.height / wi_scale;
}

export function madnes_object_rename(name, new_name) {
    if(madnes_key_exist(new_name))
    {
        console.log("Object " + new_name + " already exists.");
        return false;
    }

    madnes_objects[new_name] = madnes_objects[name];
    delete madnes_objects[name];

    return true;
}

export function madnes_set_filter(name, filterName) {
    madnes_objects[name].filters = [main_phaser.add.filter(filterName)];
}